import Splitting from 'splitting'
import h from 'hyperscript'

import { ready } from '../../base/utils'
import { svgShuffleIndices } from './_native-logo-pixelate-in'

function addtypingQuotationsEffect() {
  const quotations = document.querySelectorAll('.js-editorial-article-body blockquote')

  Splitting({ target: quotations })

  const inViewObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible', 'was-shown')
        } else {
          entry.target.classList.replace('is-visible', 'was-visible')
        }
      })
    },
    { threshold: 0.1 }
  )

  quotations.forEach((quotation) => inViewObserver.observe(quotation))
}

/**
 *
 * @param {HTMLElement} element
 * @param {string} cue
 * @param {string} audioSrc
 */
function addSoundOnElementClick(element, cue, audioSrc) {
  const audio = h('audio', {
    preload: 'auto',
    src: audioSrc,
  })
  element.setAttribute('title', cue)
  element.setAttribute('tabindex', '0')
  element.addEventListener('click', () => audio.play())
  element.addEventListener('keydown', (e) => {
    if (e.key == 'Enter') audio.play()
  })
}

function addDividerSounds() {
  const [macDivider, moofDivider] = document.querySelectorAll('.js-editorial-article-divider')
  addSoundOnElementClick(macDivider, 'Eep!', '/media/campaigns/native/wild-eep.mp3')
  addSoundOnElementClick(moofDivider, 'Moof!', '/media/campaigns/native/moof.mp3')
}

function animateLogo() {
  const svg = document.querySelector('.js-native-editorial-mac-logo')
  if (svg) {
    svgShuffleIndices(svg, 'rect')
  }
}

ready(function () {
  animateLogo()
  addtypingQuotationsEffect()
  addDividerSounds()
})
